import React, { useState, useEffect } from "react";
import styles from "./ViewPage.module.css";
import {
	tertiaryTextColor,
	secondaryTextColor,
	primaryTextColor,
	titleL,
	fw500,
	fw400,
	titleXXL,
	titleXL,
	primaryBoxShadow,
} from "../Global.module.css";
import { getShareOption, matchAccessCode } from "../helpers/api";
import { useParams } from "react-router-dom";
import ErrorIcon from "./../assets/404.svg";
import CudyLoader from "../components/reusable/Loader/CudyLoader";
import LockIcon from "../assets/lock.svg";
import SlideViewer from "../components/slidesView/SlideViewer/SlideViewer";

const ShareOptions = {
	PUBLIC: "public",
	PROTECTED: "protected",
	PRIVATE: "private",
};

export default function ViewPage(props) {
	let params = useParams();

	const [loading, setLoading] = useState(true);
	const [visibility, setVisibility] = useState(ShareOptions.PRIVATE);
	const [error, setError] = useState(false);
	const [accessGranted, setAccess] = useState(false);
	const [accessCode, setAccessCode] = useState("");
	const [slides, setSlides] = useState([]);

	useEffect(() => {
		fetchShareOption();
	}, []);

	const fetchShareOption = async () => {
		try {
			let data = await getShareOption(params.id);
			if (data) {
				if (data.shareOption === ShareOptions.PUBLIC && data.slides) {
					setSlides(data.slides);
					setAccess(true);
					setVisibility(ShareOptions.PUBLIC);
				} else if (data.shareOption === ShareOptions.PROTECTED) {
					setVisibility(ShareOptions.PROTECTED);
				}
			} else {
				setError(true);
			}
		} catch (error) {
			setError(true);
		}
		setLoading(false);
	};

	const submitAccessCode = async () => {
		if (accessCode) {
			setLoading(true);
			try {
				let data = await matchAccessCode(params.id, accessCode);
				if (data) {
					setSlides(data.slides);
					setAccess(true);
				} else {
					setError(true);
				}
			} catch (error) {
				setError(true);
			}
		}
		setLoading(false);
	};

	if (error) {
		return (
			<div className={styles.viewPage}>
				<img className={styles.errorImg} src={ErrorIcon} alt="404" />
			</div>
		);
	} else if (loading) {
		return (
			<div className={styles.loader}>
				<CudyLoader />
			</div>
		);
	} else if (visibility === ShareOptions.PUBLIC) {
		// FETCH SLIDES
		return (
			<div className={styles.viewPage}>
				{slides && accessGranted && slides.length ? (
					<SlideViewer slides={slides} />
				) : null}
			</div>
		);
	} else if (visibility === ShareOptions.PROTECTED) {
		// ASK FOR ACCESS CODE THEN SEND IT TO THE BACKEND, IF MATCHES THEN WILL RECIEVE SLIDES ELSE FALSE
		return (
			<div className={styles.viewPage}>
				{!accessGranted ? (
					<div
						className={`${styles.accessCode} ${primaryBoxShadow} ${tertiaryTextColor} ${fw500} ${titleXXL}`}
					>
						<input
							className={`${styles.accessCodeInput} ${primaryTextColor} ${fw400} ${titleXL}`}
							type="text"
							autoComplete="off"
							placeholder="Enter Access Code"
							maxLength="8"
							value={accessCode}
							onChange={(e) => setAccessCode(e.target.value)}
						/>
						<button
							className={`${styles.submitBtn} ${secondaryTextColor} ${fw500} ${titleL}`}
							onClick={submitAccessCode}
						>
							Submit
						</button>
					</div>
				) : null}
				{slides && accessGranted && slides.length ? (
					<SlideViewer slides={slides} />
				) : null}
			</div>
		);
	} else
		return (
			<div className={styles.viewPage}>
				<img
					className={styles.icon}
					src={LockIcon}
					alt="Private Mode"
					width="72px"
					height="72px"
				/>
				<p
					className={`${tertiaryTextColor} ${fw500} ${titleXXL} ${styles.message}`}
				>
					The document you are trying to access is in PRIVATE mode.
				</p>
			</div>
		);
}
